import { createStyles, makeStyles } from '@material-ui/core'

export const useAdvertisingRowStyles = makeStyles((theme) =>
  createStyles({
    root: {
      display: 'flex',
      justifyContent: 'space-between',
      margin: '16px 0 60px 0',
      gap: 20,

      [theme.breakpoints.down('xs')]: {
        width: '100%'
      }
    },

    adItem: {
      maxWidth: 354,
      width: '100%',
      height: 188,

      [theme.breakpoints.down('xs')]: {
        maxWidth: 'initial'
      }
    },

    adImage: {
      width: '100%',
      height: '100%',
      objectFit: 'contain'
    }
  })
)
